import { render, staticRenderFns } from "./MallCart.vue?vue&type=template&id=728e9ab4&scoped=true&"
import script from "./MallCart.vue?vue&type=script&lang=js&"
export * from "./MallCart.vue?vue&type=script&lang=js&"
import style0 from "./MallCart.vue?vue&type=style&index=0&id=728e9ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e9ab4",
  null
  
)

export default component.exports